import SlimSelect from 'slim-select'

export function initContact($) {
  const forms = document.querySelectorAll('.contact--form');
  if (!forms.length) return;

  forms.forEach(form => {
    const type = form.querySelector('[name="form_type"]').value;

    initGroups(form);
    initDropzone(form);
    prefill(form, type);

    form.addEventListener('submit', e => {
      e.preventDefault();

      // Honeypot
      const amispam = form.querySelector('#amispam');
      if (amispam && amispam.value) return;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      setState(form, 'loading');

      fetch(form.dataset.mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(() => {
          setState(form, 'sent');
          pushDataLayer(form, type);
          setTimeout(() => {
            form.reset();
            prefill(form, type);
            setState(form, 'submit');
          }, 5000);
        })
        .catch(error => {
          console.error(error);
          setState(form, 'submit');
          form.classList.add('has-error');
        });
    });

    // Un bouton "envoi en cours" / "merci" ne doit rien soumettre
    form.querySelectorAll('.contact--btn.is-loading, .contact--btn.is-sent').forEach(btn => {
      btn.addEventListener('click', e => e.preventDefault());
    });
  });

  function setState(form, state) {
    form.classList.remove('has-error');
    form.querySelectorAll('.contact--btn').forEach(btn => btn.classList.remove('is-active'));
    const target = form.querySelector(`.contact--btn.is-${state}`);
    if (target) target.classList.add('is-active');
  }

  /*
  *   Formulaire contact : le sujet affiche les champs du groupe correspondant (data-group)
  *   Les champs des groupes masqués sont désactivés (ni validés, ni envoyés)
  */
  function initGroups(form) {
    const select = form.querySelector('#contact-type');
    if (!select) return;

    const update = () => {
      const key = select.selectedOptions[0].dataset.group;

      form.querySelectorAll('.contact--group').forEach(group => {
        let active = group.dataset.group === key;

        // Message : toujours pour "autre" et "recrutement", sinon via "Ajouter un message"
        if (group.dataset.group === 'textarea') {
          active = key === 'autre' || key === 'recrutement' ||
            !!form.querySelector(`.contact--group[data-group="${key}"] .contact--add-message input:checked`);
        }

        group.classList.toggle('is-active', active);
        group.querySelectorAll('input, textarea, select').forEach(el => { el.disabled = !active; });
      });
    };

    // Select stylisé (le select natif reste la source de vérité pour l'envoi)
    form.contactSlim = new SlimSelect({
      select,
      settings: {
        showSearch: false,
        allowDeselect: false
      },
      events: {
        afterChange: update
      }
    });

    select.addEventListener('change', update);
    form.querySelectorAll('.contact--add-message input').forEach(input => input.addEventListener('change', update));
    form.addEventListener('reset', () => setTimeout(() => {
      form.contactSlim.setSelected(select.value);
      update();
    }));
    update();
  }

  /*
  *   Zone de dépôt des fichiers (glisser-déposer, 4 fichiers max)
  */
  function initDropzone(form) {
    const zone = form.querySelector('.contact--dropzone');
    if (!zone) return;

    const input = zone.querySelector('input[type="file"]');
    const list = zone.querySelector('.contact--dropzone-list');
    const count = zone.querySelector('.contact--dropzone-count');
    const max = 4;

    const render = () => {
      const files = [...input.files];
      list.innerHTML = '';
      files.forEach(file => {
        const li = document.createElement('li');
        li.textContent = file.name;
        list.appendChild(li);
      });
      count.textContent = `${files.length} sur ${max}`;
    };

    input.addEventListener('change', () => {
      if (input.files.length > max) {
        const transfer = new DataTransfer();
        [...input.files].slice(0, max).forEach(file => transfer.items.add(file));
        input.files = transfer.files;
      }
      render();
    });

    ['dragenter', 'dragover'].forEach(name => zone.addEventListener(name, e => {
      e.preventDefault();
      zone.classList.add('is-dragover');
    }));
    ['dragleave', 'drop'].forEach(name => zone.addEventListener(name, e => {
      e.preventDefault();
      zone.classList.remove('is-dragover');
    }));
    zone.addEventListener('drop', e => {
      input.files = e.dataTransfer.files;
      input.dispatchEvent(new Event('change'));
    });

    form.addEventListener('reset', () => setTimeout(render));
  }

  /*
  *   Pré-remplissage : ?form=construction (sujet), cookie "projet-vente" (projet), cookie "job" (offre)
  *   Les cookies sont posés dans utils/prefill-cookies.js
  */
  function prefill(form, type) {
    const cookie = name => (window.Cookies && Cookies.get(name)) || '';
    const set = (selector, value) => {
      const el = form.querySelector(selector);
      if (!el) return;
      if (value) el.value = value;
      // Champs offre / projet (lecture seule) : masqués tant qu'ils sont vides
      if (el.classList.contains('contact--flat-input')) {
        el.closest('.contact--form-group').classList.toggle('d-none', !el.value);
      }
    };

    if (type === 'contact') {
      const select = form.querySelector('#contact-type');
      const aliases = { 'vendre-terrain': 'vendre' };
      let key = new URLSearchParams(window.location.search).get('form');
      key = aliases[key] || key;
      const option = key && select.querySelector(`option[data-group="${key}"]`);
      if (option) {
        select.value = option.value;
        if (form.contactSlim) form.contactSlim.setSelected(option.value);
        select.dispatchEvent(new Event('change'));
      }
      set('#projet-vente', cookie('projet-vente'));
      set('#offre', cookie('job'));
    }

    if (type === 'vente') set('#projet', cookie('projet-vente'));
    if (type === 'recrutement') set('#offre', cookie('job'));
  }

  /*
  *   Datalayer de validation de formulaire
  */
  function pushDataLayer(form, type) {
    window.dataLayer = window.dataLayer || [];
    const value = name => (form.querySelector(`[name="${name}"]`) || {}).value || '';

    switch (type) {
      case 'contact':
        window.dataLayer.push({
          event: 'contact-form-success',
          formSubject: value('sujet'),
          chalet_name: value('sujet') === 'Projet à la vente' ? value('projet') : 'N/A'
        });
        break;
      case 'vente':
        window.dataLayer.push({ event: 'contact-form-success', formSubject: 'Projet à la vente', chalet_name: value('projet') });
        break;
      case 'terrain':
        window.dataLayer.push({ event: 'sell-land-form-success' });
        break;
      case 'recrutement':
        window.dataLayer.push({ event: 'job-application-form-success', job_name: value('offre') || 'Spontanée' });
        break;
    }
  }
}
